angular.module('dnecom')
    .controller('StoreAnalyticsController', ["$scope", "$http", "$timeout", "$location", "Utils", "StoreUtils", "notifications", function StoreAnalyticsController($scope, $http, $timeout, $location, Utils, StoreUtils, notifications) {
        $scope.store = TemplateData.value('store');

        $scope.period = 'last-month';

        $scope.medium = 'organic';
        $scope.allowedMediums = ['organic', 'referral'];

        $scope.display_type = 'all';

        $scope.loading = false;

        $scope.getCountryName = Utils.getCountryName;

        $scope.init = function() {
            $scope.updateReports();
        };

        $scope.initCharts = function() {
            $scope.mediumsChartData = {
                labels: Object.keys($scope.reports.mediums),
                datasets: [
                    {
                        data: $scope.getArrayValues($scope.reports.mediums),
                        backgroundColor: [
                            '#F55753', // direct
                            '#48B0F7', // organic search
                            '#10CFBD', // referral
                            '#FFCC00'  // social
                        ]
                    }
                ]
            };

            $scope.mediumsChartOptions = {
                animation: {
                    animateScale: true
                },
                legend: {
                    position: 'right',
                    onClick: function(event, legendItem) {
                        if ($scope.allowedMediums.indexOf(legendItem.text) != -1) {
                            $timeout(function () {
                                $scope.medium = legendItem.text;
                            });
                        }
                    }
                }
            };

            $scope.userTypesChartData = {
                labels: Object.keys($scope.reports.userTypes),
                datasets: [
                    {
                        data: $scope.getArrayValues($scope.reports.userTypes),
                        backgroundColor: [
                            '#48B0F7', // new visitors
                            '#10CFBD'  // returning visitors
                        ]
                    }
                ]
            };

            $scope.userTypesChartOptions = {
                animation: {
                    animateScale: true
                },
                legend: {
                    position: 'bottom'
                }
            };

            $scope.visitsChartData = {
                labels: Object.keys($scope.reports.visits),
                datasets: [
                    {
                        label: 'Visits',
                        data: $scope.getArrayValues($scope.reports.visits),
                        borderColor: '#48B0F7',
                        backgroundColor: 'white',
                        fill: false
                    }
                ]
            };

            $scope.visitsChartOptions = {};
        };

        $scope.updateReports = function() {
            $scope.loading = true;

            $http
                .post(
                    Routing.generate('stores_analytics_reports', { id: $scope.store.id }),
                    {
                        period: $scope.period,
                        dateFrom: $scope.dateFrom,
                        dateTo: $scope.dateTo,
                        display_type: $scope.display_type
                    }
                )
                .success(function(response) {
                    if (!response || !response.success) {
                        alert(response.message || 'Failed to update reports: invalid server response.');
                        return;
                    }

                    $scope.reports = response.reports;
                    $scope.initCharts();
                })
                .error(function() {
                    alert('Failed to update reports: invalid server response.');
                })
                .then(function() {
                    $scope.loading = false;
                })
            ;
        };

        $scope.getArrayValues = function(input) {
            var out = [];

            for (var key in input) {
                out.push(input[key]);
            }

            return out;
        };

        $scope.getArrayColumn = function(input, column) {
            var out = [];

            for (var key in input) {
                out.push(input[key][column] || 0);
            }

            return out;
        };

        $scope.storePagePath = function (path) {
            return StoreUtils.getUrl($scope.store).replace(/\/+$/, '') + path;
        };

        $scope.selectDisplayType = function (type) {
            if (type == 'mobile' && !$scope.store.mobile_store) {
                notifications.danger('Google Analytics is not enabled on mobile store. Please enable it in mobile store settings.');
                return;
            }

            $scope.display_type = type;

            $scope.updateReports();
        };
    }])
;
